module.exports = __webpack_public_path__ + "fonts/akkurat-webfont.2efaa57f.woff2";